import { useState } from 'react'

export enum EditionViews {
  edit = 'edit',
  view = 'view',
}

export function useEdition(initialView: EditionViews) {
  const [view, setView] = useState(initialView)

  const enableEdition = () => setView(EditionViews.edit)
  const disableEdition = () => setView(EditionViews.view)

  return {
    enableEdition,
    disableEdition,
    view,
  }
}
